import { ApplicationRef, ComponentRef, createComponent, Injectable, Type, inject } from '@angular/core';
import {Placement, PlacementType} from "../../models/placement.model";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DialogInteractableService {
    private readonly appRef = inject(ApplicationRef);


    private componentRef: ComponentRef<any>;
    private scrollHandler: (() => void) | null = null;
    private ARROW_OFFSET = 10;

    public open(targetElement: HTMLElement, componentType: Type<any>, placement: PlacementType, parameter?: any): Subject<any> {
        this.close();
        const resultSubject = new Subject<any>();

        this.componentRef = createComponent(componentType, {
            environmentInjector: this.appRef.injector,
        });

        this.componentRef.instance.resultSubject = resultSubject;
        if (parameter) {
            this.componentRef.instance.parameter = parameter;
        }

        this.appRef.attachView(this.componentRef.hostView);
        this.positionDialog(placement, targetElement);
        this.scrollHandler = () => this.positionDialog(placement, targetElement);

        window.addEventListener('scroll', this.scrollHandler, true);
        window.addEventListener('resize', this.scrollHandler, true);

        return resultSubject;
    }

    public close() {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler, true);
            window.removeEventListener('resize', this.scrollHandler, true);
            this.scrollHandler = null;
        }

        if (this.componentRef) {
            this.appRef.detachView(this.componentRef.hostView);
            if (this.componentRef.instance.destroy$) {
                this.componentRef.instance.destroy$.next();
            }
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    private positionDialog(placement: PlacementType, targetElement: HTMLElement) {
        const dialogElement = (this.componentRef.hostView as any).rootNodes[0] as HTMLElement;
        document.body.appendChild(dialogElement);

        const targetRect = targetElement.getBoundingClientRect();
        dialogElement.style.position = 'absolute';

        switch (placement) {
        case Placement.Top:
            dialogElement.style.top =
                `${targetRect.top - dialogElement.getBoundingClientRect().height - this.ARROW_OFFSET}px`;
            dialogElement.style.left =
                `${targetRect.left - dialogElement.getBoundingClientRect().width + targetRect.width / 2}px`;
            dialogElement.querySelector(".arrow").classList.add('tail-bottom');
            break;
        case Placement.Right:
            dialogElement.style.top =
                `${targetRect.bottom - dialogElement.getBoundingClientRect().height - targetRect.height / 2}px`;
            dialogElement.style.left = `${targetRect.left + targetRect.width + this.ARROW_OFFSET}px`;
            dialogElement.querySelector(".arrow").classList.add('tail-left');
            break;
        case Placement.Bottom:
            dialogElement.style.top = `${targetRect.bottom + this.ARROW_OFFSET}px`;
            dialogElement.style.left =
                `${targetRect.right - dialogElement.getBoundingClientRect().width - targetRect.width / 2}px`;
            dialogElement.querySelector(".arrow").classList.add('tail-top');
            break;
        case Placement.Left:
            dialogElement.style.top =
                `${targetRect.bottom - dialogElement.getBoundingClientRect().height - targetRect.height / 2}px`;
            dialogElement.style.left =
                `${targetRect.left - dialogElement.getBoundingClientRect().width - this.ARROW_OFFSET}px`;
            dialogElement.querySelector(".arrow").classList.add('tail-right');
            break;
        }
    }
}
